import { render, staticRenderFns } from "./DashboardFilterPeriod.vue?vue&type=template&id=10136222"
import script from "./DashboardFilterPeriod.vue?vue&type=script&lang=js"
export * from "./DashboardFilterPeriod.vue?vue&type=script&lang=js"
import style0 from "./DashboardFilterPeriod.vue?vue&type=style&index=0&id=10136222&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports